/* FORGE cart drawer behaviour: delivery dates, quantity/remove, upsells, shipping protection.
   Works alongside Horizon's cart-drawer / cart-items components (which handle open/close + add-to-cart morphs). */
(function () {
  if (window.__forgeCart) return;
  window.__forgeCart = true;

  var SECTION = 'cart-drawer-section';
  var busy = false;
  var upsellCache = {};

  function drawer() { return document.getElementById('cart-drawer'); }
  function root() { return document.querySelector('[data-f-cart-root]'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(src, w) { return String(src || '').replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + w + 'x$1$2'); }
  function money(cents) {
    var fmt = (root() && root().dataset.moneyFormat) || '${{amount}}';
    var n = cents / 100;
    function fixed(x, d, ts, ds) { var p = x.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds); }
    var out;
    if (fmt.indexOf('amount_no_decimals_with_comma_separator') > -1) out = fixed(n, 0, '.', ',');
    else if (fmt.indexOf('amount_with_comma_separator') > -1) out = fixed(n, 2, '.', ',');
    else if (fmt.indexOf('amount_no_decimals') > -1) out = fixed(n, 0, ',', '.');
    else out = fixed(n, 2, ',', '.');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out).replace(/<[^>]+>/g, '');
  }
  function fmtDate(d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); }

  function setBusy(b) { busy = b; var d = drawer(); if (d) d.classList.toggle('is-busy', b); }

  function rootPath() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function refresh() {
    return fetch(rootPath() + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j[SECTION]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
        var cur = root();
        if (!fresh || !cur) return;
        Array.from(fresh.attributes).forEach(function (a) { cur.setAttribute(a.name, a.value); });
        cur.innerHTML = fresh.innerHTML;
        init();
        document.dispatchEvent(new CustomEvent('forge:cart:refreshed'));
      })
      .catch(function (e) { console.warn('[forge-cart] refresh failed', e); });
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Forge-Cart': '1' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || 'Cart error'); return j; }); });
  }
  function changeByKey(key, qty) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return post('/cart/change.js', { id: key, quantity: qty }).then(refresh).catch(function (e) { alert(e.message); }).finally(function () { setBusy(false); });
  }
  function add(variantId, qty) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return post('/cart/add.js', { items: [{ id: variantId, quantity: qty || 1 }] }).then(refresh).catch(function (e) { alert(e.message); }).finally(function () { setBusy(false); });
  }

  /* Delivery dates */
  function initDates() {
    var r = root(); if (!r) return;
    var el = r.querySelector('[data-f-cart-dates]'); if (!el || el.textContent.trim()) return;
    var min = parseInt(r.dataset.min, 10) || 3, max = parseInt(r.dataset.max, 10) || 8;
    var a = new Date(), b = new Date(); a.setDate(a.getDate() + min); b.setDate(b.getDate() + max);
    el.textContent = fmtDate(a) + ' – ' + fmtDate(b);
  }

  /* Upsells */
  function upsellCard(p) {
    var vs = (p.variants || []).filter(function (v) { return v.available; });
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var url = p.url || ('/products/' + p.handle);
    var sel = vs.length > 1
      ? '<select class="f-cart__upsell-select" data-f-upsell-select aria-label="Choose an option">' + vs.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') + '</select>'
      : '<input type="hidden" data-f-upsell-select value="' + (vs[0] ? vs[0].id : '') + '" data-price="' + (vs[0] ? vs[0].price : p.price) + '">';
    return '<div class="f-cart__upsell-card" data-f-upsell-card>' +
      '<a class="f-cart__upsell-media" href="' + esc(url) + '">' + (img ? '<img class="f-cart__upsell-img" src="' + esc(sized(img, 180)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<div class="f-cart__upsell-body"><a class="f-cart__upsell-name" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
      '<div class="f-cart__upsell-price" data-f-upsell-price>' + money(vs[0] ? vs[0].price : p.price) + '</div>' +
      '<div class="f-cart__upsell-row">' + sel + '<button type="button" class="f-cart__upsell-add" data-f-upsell-add' + (vs.length ? '' : ' disabled') + '>' + (vs.length ? 'Add' : 'Sold out') + '</button></div></div></div>';
  }
  function initUpsells() {
    var r = root(); if (!r) return;
    var box = r.querySelector('[data-f-upsell]'); if (!box) return;
    var track = box.querySelector('[data-f-upsell-track]'); if (!track) return;
    var inCart = Array.from(r.querySelectorAll('[data-product-id]')).map(function (e) { return String(e.dataset.productId); });
    var exclude = String(r.dataset.protectId || '');
    var pid = inCart[0];
    if (!pid) { box.hidden = true; return; }
    if (track.dataset.for === pid && track.children.length) { box.hidden = false; return; }
    var limit = parseInt(box.dataset.limit, 10) || 4;
    var p = upsellCache[pid] ? Promise.resolve(upsellCache[pid]) : fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : { products: [] }; })
      .then(function (j) { upsellCache[pid] = j.products || []; return upsellCache[pid]; })
      .catch(function () { return []; });
    p.then(function (list) {
      list = list.filter(function (pr) { return pr.available && inCart.indexOf(String(pr.id)) < 0 && String(pr.id) !== exclude; }).slice(0, limit);
      var cur = root(); var b = cur && cur.querySelector('[data-f-upsell]'); var t = b && b.querySelector('[data-f-upsell-track]');
      if (!t) return;
      if (!list.length) { b.hidden = true; return; }
      t.innerHTML = list.map(upsellCard).join('');
      t.dataset.for = pid;
      b.hidden = false;
      updateArrows(b);
    });
  }
  function updateArrows(box) {
    var t = box.querySelector('[data-f-upsell-track]'); if (!t) return;
    var prev = box.querySelector('[data-f-upsell-prev]'), next = box.querySelector('[data-f-upsell-next]');
    var many = t.children.length > 1;
    if (prev) prev.disabled = !many || t.scrollLeft <= 2;
    if (next) next.disabled = !many || t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
  }

  function init() { initDates(); initUpsells(); }

  /* Delegated interactions (survive re-renders) */
  document.addEventListener('click', function (e) {
    var d = drawer(); if (!d) return;
    var t = e.target.closest('[data-f-qty],[data-f-remove],[data-f-upsell-add],[data-f-protect],[data-f-upsell-prev],[data-f-upsell-next]');
    if (!t || !d.contains(t)) return;
    e.preventDefault();
    if (t.hasAttribute('data-f-qty')) {
      var row = t.closest('[data-key]'); if (!row) return;
      var q = parseInt(row.dataset.qty, 10) || 1;
      var next = q + parseInt(t.dataset.fQty, 10);
      if (next < 0) next = 0;
      changeByKey(row.dataset.key, next);
    } else if (t.hasAttribute('data-f-remove')) {
      var r2 = t.closest('[data-key]'); if (r2) changeByKey(r2.dataset.key, 0);
    } else if (t.hasAttribute('data-f-upsell-add')) {
      var card = t.closest('[data-f-upsell-card]'); var s = card && card.querySelector('[data-f-upsell-select]');
      if (s && s.value) add(s.value, 1);
    } else if (t.hasAttribute('data-f-protect')) {
      if (t.getAttribute('aria-checked') === 'true') { if (t.dataset.key) changeByKey(t.dataset.key, 0); }
      else if (t.dataset.variant) add(t.dataset.variant, 1);
    } else {
      var box = t.closest('[data-f-upsell]'); var tr = box && box.querySelector('[data-f-upsell-track]'); if (!tr) return;
      tr.scrollBy({ left: (t.hasAttribute('data-f-upsell-prev') ? -1 : 1) * tr.clientWidth, behavior: 'smooth' });
      setTimeout(function () { updateArrows(box); }, 400);
    }
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-f-upsell-select]'); if (!s || !drawer() || !drawer().contains(s)) return;
    var opt = s.options && s.options[s.selectedIndex]; var price = opt && opt.dataset.price;
    var pe = s.closest('[data-f-upsell-card]').querySelector('[data-f-upsell-price]');
    if (price && pe) pe.textContent = money(parseInt(price, 10));
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (t && t.nodeType === 1 && t.hasAttribute && t.hasAttribute('data-f-upsell-track')) updateArrows(t.closest('[data-f-upsell]'));
  }, true);

  /* Re-init after Horizon morphs the drawer (add-to-cart from product forms) */
  var mo = null, moTimer = null;
  function observe() {
    var d = drawer(); if (!d || mo) return;
    mo = new MutationObserver(function () { clearTimeout(moTimer); moTimer = setTimeout(init, 120); });
    mo.observe(d, { childList: true, subtree: true });
  }
  /* Belt and braces: any non-Forge add-to-cart request refreshes the drawer markup */
  var _fetch = window.fetch;
  window.fetch = function (input, opts) {
    var p = _fetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var mine = opts && opts.headers && (opts.headers['X-Forge-Cart'] || (opts.headers.get && opts.headers.get('X-Forge-Cart')));
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !mine) p.then(function (res) { if (res && res.ok) setTimeout(function () { refresh().then(autoOpen); }, 200); }, function () {});
    } catch (err) {}
    return p;
  };
  /* Horizon's auto-open can miss the empty -> first item transition; make sure the drawer opens after any successful add */
  function autoOpen() {
    var d = drawer(), r = root(); if (!d || !r) return;
    var c = d.querySelector('cart-drawer-component');
    if (c && c.hasAttribute('auto-open') && !d.hasAttribute('open') && !r.classList.contains('cart-drawer--empty') && typeof d.open === 'function') d.open();
  }

  /* Overlay instead of Horizon's page "squeeze" on wide viewports: dim backdrop, lock page scroll */
  var wide = window.matchMedia('(min-width: 990px)');
  function backdrop() {
    var b = document.getElementById('f-cart-backdrop');
    if (!b) {
      b = document.createElement('div'); b.id = 'f-cart-backdrop'; b.className = 'f-cart-backdrop';
      b.addEventListener('click', function () { var d = drawer(); if (d && typeof d.close === 'function') d.close(); });
      document.body.appendChild(b);
    }
    return b;
  }
  function unsqueeze() { var pw = document.querySelector('.page-wrapper'); if (pw) pw.classList.remove('page-wrapper--drawer-open'); }
  document.addEventListener('theme-drawer:open', function (e) {
    if (!e.target || e.target.id !== 'cart-drawer') return;
    unsqueeze(); requestAnimationFrame(unsqueeze);
    if (wide.matches) { backdrop().classList.add('is-on'); document.documentElement.classList.add('f-cart-open'); }
  });
  document.addEventListener('theme-drawer:close', function (e) {
    if (!e.target || e.target.id !== 'cart-drawer') return;
    backdrop().classList.remove('is-on'); document.documentElement.classList.remove('f-cart-open');
  });

  function boot() { init(); observe(); var d = drawer(); if (d && d.hasAttribute('open')) { unsqueeze(); if (wide.matches) { backdrop().classList.add('is-on'); document.documentElement.classList.add('f-cart-open'); } } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.forgeCart = { refresh: refresh, add: add, changeByKey: changeByKey };
})();
